import "./Dashboard.scss";
import { useState } from 'react';
import { useEffect } from 'react';
import api from '../../../api.js';
import { toast } from 'react-toastify';
import { useContext } from 'react';
import { AppContext } from '../../../context/AppContext';
import "./Dashboard.scss";
import { useNavigate } from "react-router-dom";
import { keyToPathMap } from "./dashboardUtils.js";
import { groupedCounts } from "./dashboardUtils.js";

const Dashboard = () => {

    const [allCounts, setAllCounts] = useState({});
    const { backendUrl } = useContext(AppContext);
    const navigate = useNavigate();

    async function fetchAllCounts() {
        try {
            const { data } = await api.get(`${backendUrl}/api/auth/getAllDocuments`);
            if (data.success) {
                setAllCounts(data.counts || []);
            } else {
                setAllCounts({});
            }
        } catch (error) {
            if (error.response) {
                toast.error("Server error: Unable to retrieve counts. Please contact support.");
            } else if (error.request) {
                if (!navigator.onLine) {
                    toast.error("No internet connection. Please check your network and try again.");
                } else {
                    toast.error("Server is unreachable. Please try again later.");
                }
            } else {
                toast.error("Unexpected error occurred while fetching counts.");
            }
        }
    }

    useEffect(() => {
        fetchAllCounts();
    }, []);


    return (
        <div className="dashboardContainer">
            <h1 className="dashboardTitle" style={{ fontFamily: "var(--font-h2)", fontWeight: "400", fontSize: "26px", color: "darkgreen" }}>📊 Admin Dashboard</h1>
            {Object.entries(groupedCounts).map(([section, items]) => (
                <div className="dashboardSection" key={section}>
                    <h2 className="dashboardSectionTitle" style={{ fontFamily: "var(--font-h2)", fontSize: "var(--h2-font-size)", color: "#116C4A" }}>{section}</h2>
                    <div className="dashboardCards">
                        {items.map(({ title, key }) => (
                            <div className="dashboard-card" key={key}
                                onClick={() => {
                                    const route = keyToPathMap[key];
                                    if (route) navigate(route);
                                    else toast.warning("Route not defined for: " + key);
                                }}
                                style={{ cursor: "pointer" }}
                            >
                                <div className="card-title" style={{ fontFamily: "var(--font-paragraph)", fontSize: "var(--paragraph-font-size)", fontWeight: "600" }}>{title}</div>
                                <div className="card-count" style={{ fontFamily: "var(--font-h2)", fontSize: "var(--h1-font-size)", color: "#116C4A" }}>{allCounts[key] ?? 0}</div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    )
};

export default Dashboard
